import teras from '@/teras'

import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/components/Home'
import Fad from '@/components/Fad'
import EventoHome from '@/components/Evento-home'
import EventoSearch from '@/components/Evento-search'
import Loadpage from '@/components/Loadpage'
import PageEdit from '@/components/Page-edit'

import Mylogin from '@/components/Mylogin'
import MyloginHome from '@/components/Mylogin-home'
import MyloginRes from '@/components/Mylogin-res'
import MyloginFad from '@/components/Mylogin-fad'
import MyloginCrediti from '@/components/Mylogin-crediti'

import ContattoEdit from '@/components/Contatto-edit'
import ContattoPassword from '@/components/Contatto-password'
import ContattoPrivacy from '@/components/Contatto-privacy'

import NlEdit from '@/components/Nl-edit'


Vue.use(VueRouter)

var mode = (process.env.NODE_ENV != 'development') ? 'history' : 'hash'

const router = new VueRouter({

  mode: mode,
  base: '/corsi-convegni/',

  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  },

  routes: [
    { path: '/',  redirect: '/home'},
    
    { path: '/home', name: 'home', meta: { nav: true }, components:{main: Home  }, props: {main: true, page:'mirko' } }, 
    { path: '/fad', name: 'fad', meta: { nav: true }, components:{main: Fad  }, props: {main: true } },  
    { path: '/evento-home/:id/:lang?', name: 'evento', meta: { nav: true, lang: true }, components:{main: EventoHome  }, props: {main: true } }, 
    { path: '/evento-demo/:id/:isdemo?', name: 'evento', meta: { nav: true, lang: true }, components:{main: EventoHome  }, props: {main: true } }, 
    { path: '/evento-search/:tipo/:iniziail?/:finisceil?/:interesse?/:provider?/:citta?', name: 'eventoSearch', meta: { nav: true }, components:{main: EventoSearch  }, props: {main: true } }, 

    { path: '/loadpage/:area/:filename', name: 'inside',  meta: { inside:'inside', nav: true }, components:{main: Loadpage },props: {main: true} }, 
    { path: '/page-edit', name: 'pageEdit', meta: { requiresAuth: false }, components: { main: PageEdit } },

    { path: '/mylogin', name: 'mylogin', meta: { nav: true }, components:{main: Mylogin  }, props: {main: true, page:'mirko' } },
    { path: '/mylogin-home', name: 'myloginHome', meta: { requiresAuth: true }, components:{main: MyloginHome  }, props: {main: true } },
    { path: '/mylogin-res', name: 'myloginRes', meta: { requiresAuth: true }, components:{main: MyloginRes  }, props: {main: true } },   
    { path: '/mylogin-fad', name: 'myloginFad', meta: { requiresAuth: true }, components:{main: MyloginFad  }, props: {main: true } },   
    { path: '/mylogin-crediti', name: 'myloginCrediti', meta: { requiresAuth: true }, components:{main: MyloginCrediti }, props: {main: true } },  

    { path: '/contatto-edit', name: 'contatto.edit', meta: { requiresAuth: true }, components: { main: ContattoEdit } }, 
    { path: '/contatto-password', name: 'contatto.password', meta: { requiresAuth: true }, components: { main: ContattoPassword } }, 
    { path: '/contatto-privacy', name: 'contatto.privacy', meta: { requiresAuth: true }, components: { main: ContattoPrivacy } }, 



    { path: '/nl-edit', name: 'nlEdit', meta: { area: 'group' }, components:{main: NlEdit } },


    { path: '*', redirect: '/home' } 
  ]


})

router.beforeEach((to, from, next) => {
   console.log("\nbeforeEach \nfrom: "+from.path+"\nto: "+to.path+"\n\n")

      if(to.path=='/evento-home/2354')
      window.location.href = "http://congresso.sip.it/2018";
         
      if(to.path=='/evento-home/2366')
      window.location.href = "http://congresso.neonatologia.it/2018";

      if(to.path=='/evento-home/2360')
      window.location.href = "http://congresso.sogenp.org/2018";

      if(to.path=='/evento-home/2361')
      window.location.href = "http://congresso.sibioc.it/2018";
         
      if(to.path=='/evento-home/2402')
      window.location.href = "http://congresso.sinepe.it/2018";
         
      if(to.path=='/evento-home/2367')
      window.location.href = "http://congresso.neurologiapediatrica.it/2018";
         
      if(to.path=='/evento-home/2362')
      window.location.href = "http://congresso.sigu.net/2018";
      
   
   if(!teras.app.ready){
      if(teras.ttl()){
         console.log("TTLCLEAR lancio appClear")
         teras.event.emit('appClear')
      }
      console.log("EFFETTUO LE OPERAZIONI AL PRIMO AVVIO DELLA APP "+ teras.name)
      teras.event.emit('routerFirst', to)
      return true
   }

   if (to.matched.some(record => record.meta.requiresAuth)){
      console.log("SONO RICHIESTI I PERMESSI..... LI CONTROLLO")
      if(teras.app.auth){
         console.log("....PERMESSI VERIFICATI, PROCEDO!")
         next()
      }else{
         console.log("....PERMESSI MANCANTI, LO MANDO A: "+teras.app.routeInitial)
         teras.event.emit('routerNoauth',to)
         next(teras.app.routeNoauth)
      }
   }else{
      console.log("NON SONO RICHIESTI PERMESSI")
      next()
   }

   teras.event.emit('routerChange', to)
})

export default router


// WEBPACK FOOTER //
// ./src/router.js